// composables/useChatPhases.js
import { ref, computed } from 'vue'
import { chatStateManager } from '../lib/chatStateManager'

export function useChatPhases() {
  const showTransitionForm = ref(false);
  const showAgentTimeout = ref(false);

  const currentPhaseComponent = computed(() => {
    if (showAgentTimeout.value) {
      return 'AgentTimeout';
    }
    
    const phaseMap = {
      'start': 'ChatStart',
      'ai': 'ChatAI', 
      'human': 'ChatHuman',
      'end': 'ChatEnd'
    };
    
    const state = chatStateManager.getState();
    return phaseMap[state.currentPhase] || 'ChatStart';
  });

  const handlePhaseComplete = (data) => {
    const currentState = chatStateManager.getState();
    console.log('🔄 Phase transition:', currentState.currentPhase, '→', data.nextPhase, data);
    
    if (currentState.currentPhase === 'start' && data.nextPhase === 'ai') {
      chatStateManager.startNewChat(
        data.customer,
        data.conversation,
        data.customerName
      );
      
      showTransitionForm.value = true;
      
      setTimeout(() => {
        chatStateManager.updateState({ currentPhase: data.nextPhase });
        showTransitionForm.value = false;
        console.log('🤖 Entering AI phase');
      }, 3000);
    } else {
      chatStateManager.updateState({ currentPhase: data.nextPhase });
    }
  };

  const transitionToPhase = (phase) => {
    console.log(`🔄 Transitioning to phase: ${phase}`);
    chatStateManager.updateState({ currentPhase: phase });
  };

  const triggerMoodRating = () => {
    transitionToPhase('end');
  };

const handleStartNewChat = () => {
  console.log('🆕 Starting new chat from end screen');
  chatStateManager.completeRestart(); // ✅ Use the method that actually exists!
};

  return {
    showTransitionForm,
    showAgentTimeout,
    currentPhaseComponent,
    handlePhaseComplete,
    transitionToPhase,
    triggerMoodRating,
    handleStartNewChat
  };
}